import { FETCH_RESPONDENTS, SET_RESPONDENT_DATES } from "./respondant-store-constants"

export function fetchRespondents(data) {
  return {
    type: FETCH_RESPONDENTS,
    payload: {
      respondents: data
    }
  }
}

export function setRespondentDates(dates) {
  return {
    type: SET_RESPONDENT_DATES,
    payload: {
      startDate: dates.startDate,
      endDate: dates.endDate
    }
  }
}